"use strict";

import {onFind, initInScope} from "@elements/init-modules-in-scope";
import {on, addClass, removeClass, findIn} from "@elements/dom-utils";
import asyncAppend from "@elements/async-append";
import axios from "axios";
import {setCartCount, updateCart} from "./load-cart";
import {openCartFlyOut} from "./nav";
import {resultTracking} from "@elements/tracking";

const defaultOptions = {};

const defaultSelectors = {
    base: '.js-merchandise',
    input: '.js-merchandise__size-input',
    loading: '.js-merchandise__loading',
    result: '.js-merchandise__result',
    form: '.js-merchandise__form',
    submit: '.js-merchandise__submit',
};

const isMobile = () => matchMedia('(max-width: 767px)').matches;

export function init(options = defaultOptions, selectors = defaultSelectors) {

    onFind(selectors.base, function (baseElement) {

        on('change', function(evt){
            evt.preventDefault();

            let input = findIn(selectors.input, baseElement);
            if(evt.target === input){
                let url = input.options[input.selectedIndex].getAttribute("data-merchandise-ajax-url");
                let pendingRequest = null;

                pendingRequest = axios(
                    {
                        method: 'GET',
                        url: url,
                        headers: {'X-Requested-With': 'XMLHttpRequest'}
                    }
                );

                asyncAppend({
                    target: findIn(selectors.result, baseElement),
                    loading: findIn(selectors.loading, baseElement)
                }, pendingRequest.then((x) => x.data));

                initInScope(findIn(selectors.result, baseElement));

                return pendingRequest;
            }
        }, baseElement);


        onFind(selectors.form, function (formElement) {
            on('submit', function(evt){
                evt.preventDefault();
                let url = formElement.getAttribute("data-action");
                let btn = findIn(selectors.submit, formElement);
                let data = new FormData(formElement);
                axios({method: 'POST', url: url, data: data, headers: {'X-Requested-With': 'XMLHttpRequest'}}).then(function (x){
                    updateCart();
                    openCartFlyOut();

                    if(x.data.hasOwnProperty('cartItemsCounter')){
                        setCartCount(x.data.cartItemsCounter);
                    }

                    let result = x.data;
                    console.log("result", result);
                    if (result){
                        resultTracking(result);
                    } else {
                        console.warn('No Tracking Result');
                    }
                });
                addClass('is-active', btn);

                setTimeout(() => {
                    removeClass('is-active', btn);
                }, 3000);

            }, formElement);
        });
    });
}

